import { Registry } from '../utils/Registry';
import { FieldConfigPropertyItem } from '../types/fieldOverrides';

export class FieldConfigOptionsRegistry extends Registry<FieldConfigPropertyItem> {}
